export default {
      ImportTypes: 'ImportType|ImportTypes',
      ImportTypes_no_body: 'ImportType',

};
